import { loadScript } from '@services/utils.service';

const { VITE_GA_MEASUREMENT_ID, VITE_PLAUSIBLE_DOMAIN } = import.meta.env;

async function initAnalytics() {
  if (!VITE_GA_MEASUREMENT_ID && !VITE_PLAUSIBLE_DOMAIN) {
    console.log('Analytics not configured');
  }

  if (VITE_GA_MEASUREMENT_ID) {
    await loadScript(
      `https://www.googletagmanager.com/gtag/js?id=${VITE_GA_MEASUREMENT_ID}`,
      { async: true },
    );

    window.dataLayer = window.dataLayer || [];

    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    gtag('js', new Date());

    gtag('config', VITE_GA_MEASUREMENT_ID, {
      debug_mode: import.meta.env.VITE_NAZKA_ENV !== 'production',
    });
  }

  if (VITE_PLAUSIBLE_DOMAIN) {
    await loadScript(
      'https://plausible.io/js/script.js',
      { 'defer': true, 'data-domain': VITE_PLAUSIBLE_DOMAIN },
    );

    if (!window.plausible) {
      window.plausible = function plausible() {
        (window.plausible.q = window.plausible.q || []).push(arguments);
      };
    }
  }
}

export { initAnalytics };
